import React, { useState } from 'react'
import worker from '../../assets/Images/worker.png'
import { Input } from 'antd'
import { Header } from '../../Components/index'
import { Button } from 'antd'
import { ModalProgress } from '../../Components'
import { errorMessage } from '../../utils/helpers'
import axios from 'axios'
import moment from 'moment'

const Details = (props) => {
    const { setProgress, progress, setRoof, setPay, value, setPrenom, selectedValue, setNom, setTelephone, setEmail, prenom, nom, telephone, email, } = props
    const [disbale, setDisable] = useState(false)
    const [modalOpen, setModalOpen] = useState(false)

    const submitDetail = () => {
        if (!nom?.length || !telephone?.length || !email?.length || !prenom?.length) {
            setDisable(true)
            return errorMessage('Champ manquant')
        }
        let raw = JSON.stringify({
            "nom": nom,
            "prenom": prenom,
            "mail": email,
            "phone": telephone,
            "adresse": value,
            "date": moment().format('YYYY-MM-DD'),
            "hour": moment().format('hh:mm:ss a'),
            "surface": selectedValue?.val
            // 'id': Math.floor(Math.random() * 99) + 1
        })

        axios.post('https://script.google.com/macros/s/AKfycbwnz92EJ0cQx0ZKyjY1T8quFF8G3ioKpFOa2ZrmdgiOD69reIyjJWnbXCWAHPUFTG8m/exec', raw)
            .then((res) => {
                const { data } = res
                if (data?.success) {
                    console.log('d',data)
                    setModalOpen(true)
                }
            }).catch((e) => {
                errorMessage(e.message)
                console.log('e', e)
            })
    }
    return (
        <>
            <div>
                <Header heading='Simulez votre projet photovoltaique !' />
                <div className='inner_div'>
                    <div className='worker_div' >
                        <img src={worker} className='worker_img' />
                    </div>
                    <div className='section_container'  >
                        <div className="section detailSection">
                            <div className='step_progress'>
                                <div className='address_step'></div>
                                <div className='address_step'></div>
                                <div className='address_step'></div>
                                <div className='address_step'></div>


                            </div>
                            <div className="details_section">
                                <div className="details_Inputs_section first_inputs">
                                    <div className="input_one">
                                        <h2>Prénom</h2>
                                        <Input value={prenom} onChange={(e) => setPrenom(e?.target?.value)} type="text" className='Input my-input' placeholder='Bastien' required />
                                    </div>
                                    <div className="input_one margin">
                                        <h2>Nom</h2>
                                        <Input value={nom} onChange={(e) => setNom(e?.target?.value)} type="number " className='Input my-input' placeholder='Dupont' required />
                                    </div>
                                </div>
                                <div className="details_Inputs_section second_inputs">
                                    <div className="input_one">
                                        <h2>Téléphone</h2>
                                        <Input value={telephone} onChange={(e) => setTelephone(e?.target?.value)} type="number" className='Input my-input  email_input  ' placeholder='0612345678' required />
                                    </div>
                                    <div className="input_one margin">
                                        <h2>Email</h2>
                                        <Input value={email} onChange={(e) => setEmail(e?.target?.value)} type="email" className='Input my-input' placeholder='bastiendupont@mail.fr' required />
                                    </div>
                                </div>

                                <div className="DETAIL_BTN">
                                    <div className='Button_div Précédent  width ' onClick={() => setRoof(false)}>
                                        <Button className='map_btn width'>Précédent</Button>
                                    </div>
                                    <div>
                                        <ModalProgress className='modal_btn' modalOpen={modalOpen} onClick={submitDetail} setProgress={setProgress} progress={progress} />
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Details
